import {
  faArrowTrendDown,
  faBox,
  faCalendarDays,
  faChartColumn,
  faCube,
  faMapLocationDot,
  faReceipt,
} from "@fortawesome/free-solid-svg-icons";

export const NAVY = "#233f66";
export const BLUE = "#1a5691";
export const CORAL = "#ff6a6f";
export const SUCCESS = "#047857";
export const DANGER = "#dc2626";
export const AMBER = "#d97706";
export const MUTED = "#6b7fa3";

export const initialFilters = {
  financialYear: "",
  financialQuarter: "",
  parentCompany: [],
  childCompany: [],
  carrier: [],
  service: [],
};

export const initialOptions = {
  financialYears: [],
  financialQuarters: {},
  parentCompanies: [],
  childCompanies: {},
  carriers: [],
  services: {},
};

export const initialSummary = {
  totalConsignments: 0,
  consignmentsQoqPct: 0,
  difotPct: 0,
  difotQoqChange: 0,
  dlRate: 0,
  dlQoqChange: 0,
  totalSpend: 0,
  spendQoqPct: 0,
  podRate: 0,
  podQoqChange: 0,
};

export const summaryTabs = [
  { id: "summary", label: "DIFOT Summary", icon: faBox },
  { id: "geo", label: "Geographical", icon: faMapLocationDot },
  { id: "freight", label: "Freight", icon: faReceipt },
  { id: "timePeriod", label: "Time Period", icon: faCalendarDays },
  { id: "surcharges", label: "Surcharges", icon: faCube },
  { id: "trends", label: "Trends & Charts", icon: faChartColumn },
];

export const tableConfigs = [
  { key: "byDaysLate", endpoint: "by-days-late", title: "By Days Late", icon: faArrowTrendDown, rulesKey: "byDaysLate", dimensionColumns: [{ key: "daysLate", label: "Days Late" }] },
  { key: "byReason", endpoint: "by-reason", title: "By KPI Explanation — Failure Reason", icon: faBox, dimensionColumns: [{ key: "kpiExplanation", label: "KPI Explanation" }] },
  { key: "byServiceType", endpoint: "by-service-type", title: "By Service Type", icon: faReceipt, rulesKey: "byServiceType", dimensionColumns: [{ key: "serviceType", label: "Service Type" }] },
  { key: "byService", endpoint: "by-service", title: "By Carrier", icon: faReceipt, rulesKey: "byService", dimensionColumns: [{ key: "carrier", label: "Carrier" }] },
  { key: "byCarrierAndService", endpoint: "by-carrier-and-service", title: "Carrier Service", icon: faReceipt, rulesKey: "byCarrierAndService", dimensionColumns: [{ key: "carrier", label: "Carrier" }, { key: "serviceType", label: "Service Type" }] },
  { key: "byFyMonth", endpoint: "by-fy-month", title: "By FY Month", icon: faCalendarDays, rulesKey: "byFyMonth", dimensionColumns: [{ key: "fyMonth", label: "FY Month" }, { key: "calendarMonth", label: "Calendar Month" }] },
  { key: "byFyQuarter", endpoint: "by-fy-quarter", title: "By FY Quarter", icon: faCalendarDays, rulesKey: "byFyQuarter", dimensionColumns: [{ key: "fyQuarter", label: "FY Quarter" }, { key: "calendarRange", label: "Calendar Range" }] },
  { key: "byFromState", endpoint: "by-from-state", title: "By From State", icon: faMapLocationDot, rulesKey: "byFromState", dimensionColumns: [{ key: "fromState", label: "From State" }] },
  { key: "byToState", endpoint: "by-to-state", title: "By To State", icon: faMapLocationDot, rulesKey: "byToState", dimensionColumns: [{ key: "toState", label: "To State" }] },
  { key: "byFromStateAndCompany", endpoint: "by-from-state-and-company", title: "By From State — Child Company", icon: faMapLocationDot, dimensionColumns: [{ key: "fromState", label: "From State" }] },
  { key: "byToStateAndMetroRegional", endpoint: "by-to-state-and-metro-regional", title: "By To State — Metro / Rural", icon: faMapLocationDot, rulesKey: "byToStateAndMetroRegional", dimensionColumns: [{ key: "toState", label: "To State" }], childColumn: { key: "metroRegional", label: "Metro / Rural" }, childrenKey: "childMetroRegional" },
  { key: "top10BestLanes", endpoint: "top10-best-lanes", title: "Top 10 Lanes by Spend", icon: faMapLocationDot, rulesKey: "top10BestLanes", dimensionColumns: [{ key: "fromState", label: "From State" }, { key: "toState", label: "To State" }] },
  { key: "top10WorstLanes", endpoint: "top10-worst-lanes", title: "Top 10 Underperforming Lanes", icon: faMapLocationDot, rulesKey: "top10WorstLanes", dimensionColumns: [{ key: "fromState", label: "From State" }, { key: "toState", label: "To State" }] },
  { key: "top10KnownReceivers", endpoint: "top10-known-receivers", title: "Top 10 Receivers", icon: faReceipt, rulesKey: "top10KnownReceivers", dimensionColumns: [{ key: "receiverName", label: "Receiver Name" }] },
  { key: "top10ReceiversCompletedAndReportable", endpoint: "top10-receivers-completed-and-reportable", title: "Top 10 Receivers (Completed & Reportable)", icon: faReceipt, rulesKey: "top10ReceiversCompletedAndReportable", dimensionColumns: [{ key: "receiverName", label: "Receiver Name" }] },
  { key: "top20Senders", endpoint: "top20-senders", title: "Senders Name", icon: faReceipt, rulesKey: "top20Senders", dimensionColumns: [{ key: "senderName", label: "Sender Name" }] },
];

const baseScope = "Base scope excludes deleted consignments and Quote status.";
const completedReportableScope = "Status included: Complete, Complete - Returned To Sender, Damaged, Lost.";
const cancelledExclusionScope =
  "Status excluded: Quote, Cancelled, Cancelled - Failed Delivery, Cancelled - Failed Pickup, Deleted.";
const kpiScopeRule = "Only KPI-scope consignments are included.";
const sharedScopeRules = [baseScope];

const withSharedScope = (rules) => [...rules, kpiScopeRule, ...sharedScopeRules];
const withL12mScope = (rules) => [...rules, ...sharedScopeRules];

export const qbrVisualizationRules = {
  byStatus: {
    groups: [
      {
        title: "DIFOT % By Status",
        items: [
          "Rows are grouped into Completed, In Transit, Damaged/Lost, Cancelled, Unreported, and All Cons.",
          kpiScopeRule,
          ...sharedScopeRules,
        ],
      },
    ],
  },
  byDaysLate: {
    groups: [
      {
        title: "By Days Late",
        items: withSharedScope([
          completedReportableScope,
        ]),
      },
    ],
  },
  byReason: {
    groups: [
      {
        title: "By KPI Explanation Failure Reason",
        items: withSharedScope([
          "Only KPI misses are included.",
          cancelledExclusionScope,
          "KPI explanation/reason must be nonblank.",
        ]),
      },
    ],
  },
  byServiceType: {
    groups: [
      {
        title: "By Service Type",
        items: withSharedScope([
          completedReportableScope,
          "Service type must be nonblank.",
          "The UI hides Unmapped rows from this table.",
        ]),
      },
    ],
  },
  byService: {
    groups: [
      {
        title: "By Carrier",
        items: withSharedScope([
          completedReportableScope,
          "Carrier must be nonblank.",
        ]),
      },
    ],
  },
  byCarrierAndService: {
    groups: [
      {
        title: "Carrier Service",
        items: withSharedScope([
          completedReportableScope,
          "Carrier must be nonblank.",
          "Service type must be nonblank.",
        ]),
      },
    ],
  },
  byFyMonth: {
    groups: [
      {
        title: "By FY Month",
        items: withL12mScope([
          "Covers the last 12 months ending at the selected quarter end.",
          cancelledExclusionScope,
        ]),
      },
    ],
  },
  byFyQuarter: {
    groups: [
      {
        title: "By FY Quarter",
        items: withL12mScope([
          "Covers the last 12 months ending at the selected quarter end.",
          cancelledExclusionScope,
        ]),
      },
    ],
  },
  byFromState: {
    groups: [
      {
        title: "By From State",
        items: withSharedScope([
          completedReportableScope,
          "Origin state must be nonblank.",
        ]),
      },
    ],
  },
  byToState: {
    groups: [
      {
        title: "By To State",
        items: withSharedScope([
          completedReportableScope,
          "Destination state must be nonblank.",
        ]),
      },
    ],
  },
  byFromStateAndCompany: {
    groups: [
      {
        title: "By From State - Child Company",
        items: withSharedScope([
          completedReportableScope,
          "Origin state must be nonblank.",
          "Child company filter/scope uses company from customer dimension.",
        ]),
      },
    ],
  },
  byToStateAndMetroRegional: {
    groups: [
      {
        title: "By To State - Metro / Rural",
        items: withSharedScope([
          completedReportableScope,
          "Destination state must be nonblank.",
          "Metro / Rural is read from the destination carrier zone (DIM_CARRIER_ZONES.METRO_REGIONAL).",
          "Consignments with no mapped destination zone are grouped as Unclassified, so the zone rows always sum back to the state row.",
        ]),
      },
    ],
  },
  top10BestLanes: {
    groups: [
      {
        title: "Top 10 Lanes by Spend",
        items: withSharedScope([
          completedReportableScope,
          "Origin and destination states must both be nonblank.",
        ]),
      },
    ],
  },
  top10WorstLanes: {
    groups: [
      {
        title: "Top 10 Underperforming Lanes",
        items: withSharedScope([
          completedReportableScope,
          "Origin and destination states must both be nonblank.",
        ]),
      },
    ],
  },
  top10KnownReceivers: {
    groups: [
      {
        title: "Top 10 Receivers",
        items: withSharedScope([
          "Receiver must be nonblank and must not start with UNKNOWN.",
        ]),
      },
    ],
  },
  top10ReceiversCompletedAndReportable: {
    groups: [
      {
        title: "Top 10 Receivers Completed & Reportable",
        items: withSharedScope([
          completedReportableScope,
          "Receiver must be nonblank and must not start with UNKNOWN.",
        ]),
      },
    ],
  },
  top20Senders: {
    groups: [
      {
        title: "Senders Name",
        items: withSharedScope([
          "Sender must be nonblank and must not start with UNKNOWN.",
        ]),
      },
    ],
  },
  top10Surcharges: {
    groups: [
      {
        title: "Top 10 Surcharges by Spend",
        items: [
          "Combines Dangerous Goods from DIM_CONSIGNMENT_INFO with active, non-deleted consignment question text.",
          cancelledExclusionScope,
          ...sharedScopeRules,
        ],
      },
    ],
  },
  surchargeTrends: {
    groups: [
      {
        title: "Surcharge Trends",
        items: [
          "Trend window is the last 12 months ending at the selected quarter end.",
          "Surcharge categories included: Dangerous Goods, Fuel, Residential, Total Surcharge.",
          ...sharedScopeRules,
        ],
      },
    ],
  },
  deliveryPerformance: {
    groups: [
      {
        title: "Delivery Performance",
        items: [
          "Chart window is the last four financial quarters up to the selected quarter.",
          completedReportableScope,
          ...sharedScopeRules,
        ],
      },
    ],
  },
  freightSpendTrend: {
    groups: [
      {
        title: "Freight Spend Trend",
        items: [
          "Chart window is the last four financial quarters up to the selected quarter.",
          cancelledExclusionScope,
          ...sharedScopeRules,
        ],
      },
    ],
  },
  quarterlyAverages: {
    groups: [
      {
        title: "Quarterly Averages",
        items: [
          "Rows exclude statuses containing Cancel.",
          ...sharedScopeRules,
        ],
      },
    ],
  },
  freightSpendByFromState: {
    groups: [
      {
        title: "Freight Spend by From State",
        items: [
          "Current selected quarter only.",
          "Uses origin state; state must be nonblank.",
          cancelledExclusionScope,
          ...sharedScopeRules,
        ],
      },
    ],
  },
  freightSpendByToState: {
    groups: [
      {
        title: "Freight Spend by To State",
        items: [
          "Current selected quarter only.",
          "Uses destination state; state must be nonblank.",
          cancelledExclusionScope,
          ...sharedScopeRules,
        ],
      },
    ],
  },
  summaryTotalConsignments: {
    groups: [
      {
        title: "Total Cons",
        items: [
          completedReportableScope,
          baseScope,
        ],
      },
    ],
  },
  summaryTotalSpend: {
    groups: [
      {
        title: "Total Spend",
        items: [
          completedReportableScope,
          baseScope,
        ],
      },
    ],
  },
  summaryDifot: {
    groups: [
      {
        title: "DIFOT %",
        items: [
          completedReportableScope,
          baseScope,
        ],
      },
    ],
  },
  summaryDamageLoss: {
    groups: [
      {
        title: "Damage and Losses %",
        items: [
          completedReportableScope,
          baseScope,
        ],
      },
    ],
  },
  summaryPod: {
    groups: [
      {
        title: "POD %",
        items: [
          completedReportableScope,
          baseScope,
        ],
      },
    ],
  },
};

export const tableHeaders = [
  { key: "consignments", label: "Consignments" },
  { key: "kpiHit", label: "KPI Hit" },
  { key: "difotPct", label: "DIFOT %" },
  { key: "consignmentsQoqPct", label: "DIFOT QoQ Change" },
  { key: "priorQConsignments", label: "Prior Q Consignments", muted: true },
  { key: "priorQKpiHit", label: "Prior Q KPI Hit", muted: true },
  { key: "priorQDifotPct", label: "Prior Q DIFOT %", muted: true },
  { key: "priorQSpend", label: "Prior Q Spend $", muted: true },
  { key: "dlCount", label: "D&L Count" },
  { key: "dlPct", label: "D&L %" },
  { key: "podCount", label: "POD Count" },
  { key: "podPct", label: "POD %" },
  { key: "spend", label: "Spend $" },
  { key: "spendQoqPct", label: "Spend $ QoQ %" },
  { key: "spendYtd", label: "Spend $ YTD" },
  { key: "items", label: "Items" },
  { key: "itemsPerCon", label: "Items / Con" },
  { key: "weightKg", label: "Weight (KG)" },
  { key: "spendPerKg", label: "Spend $/KG" },
  { key: "kgPerCon", label: "KG / Con" },
];

export const statusHeaders = [
  { key: "totalCons", label: "Total Cons" },
  { key: "consignmentsQoqPct", label: "Q Over Q" },
  { key: "dlCount", label: "D&L" },
  { key: "dlPct", label: "D&L %" },
  { key: "podCount", label: "# POD" },
  { key: "podPct", label: "POD %" },
  { key: "spend", label: "Spend $" },
];

export const periodHeaders = [
  { key: "consignments", label: "Consignments" },
  { key: "kpiHit", label: "KPI Hit" },
  { key: "difotPct", label: "DIFOT %" },
  { key: "dlCount", label: "D&L Count" },
  { key: "dlPct", label: "D&L %" },
  { key: "podCount", label: "POD Count" },
  { key: "podPct", label: "POD %" },
  { key: "spend", label: "Spend $" },
  { key: "items", label: "Items" },
  { key: "itemsPerCon", label: "Items / Con" },
  { key: "weightKg", label: "Weight (KG)" },
  { key: "spendPerKg", label: "Spend $/KG" },
  { key: "kgPerCon", label: "KG / Con" },
];

export const fyQuarterHeaders = [
  ...periodHeaders,
  { key: "priorQConsignments", label: "Prior Q Consignments", muted: true },
  { key: "priorQKpiHit", label: "Prior Q KPI Hit", muted: true },
  { key: "priorQDifotPct", label: "Prior Q DIFOT %", muted: true },
  { key: "consignmentsQoqPct", label: "DIFOT QoQ Change" },
  { key: "priorQDlPct", label: "Prior Q D&L %", muted: true },
  { key: "dlQoqChange", label: "D&L QoQ Change" },
  { key: "priorQPodPct", label: "Prior Q POD %", muted: true },
  { key: "podQoqChange", label: "POD QoQ Change" },
  { key: "priorQSpend", label: "Prior Q Spend $", muted: true },
  { key: "spendQoqPct", label: "Spend QoQ %" },
];

export const surchargeHeaders = [
  { key: "consignments", label: "Consignments" },
  { key: "priorQConsignments", label: "Prior Q Consignments" },
  { key: "consignmentsQoqPct", label: "Consignments QoQ %" },
  { key: "spend", label: "Spend $" },
  { key: "priorQSpend", label: "Prior Q Spend $" },
  { key: "spendQoqPct", label: "Spend $ QoQ %" },
];

export const emptyTrendEntry = { total: 0, spend: 0, trend: [] };
export const initialSurchargeTrends = {
  dangerousGoods: emptyTrendEntry,
  fuel: emptyTrendEntry,
  residential: emptyTrendEntry,
  totalSurcharge: emptyTrendEntry,
};

export const TREND_CHARTS = [
  { key: "dangerousGoods", title: "Dangerous Goods" },
  { key: "fuel", title: "Fuel" },
  { key: "residential", title: "Residential" },
  { key: "totalSurcharge", title: "Total Surcharge" },
];

export const emptyDeliveryPerformancePanel = { axis_right_min: 0, axis_right_max: 100, data: [] };
export const emptyDeliveryPerformanceChart = {
  title: "",
  subtitle: "",
  type: "combo",
  series: [],
  monthly: emptyDeliveryPerformancePanel,
  quarterly: emptyDeliveryPerformancePanel,
};
export const emptyFreightSpendTrendChart = {
  title: "",
  subtitle: "",
  type: "bar",
  series: [],
  monthly: { data: [] },
  quarterly: { data: [] },
};
export const emptyQuarterlyAverageMetric = { title: "", format: "number", decimals: 1, series: [], data: [] };
export const emptyQuarterlyAveragesChart = {
  title: "",
  subtitle: "",
  type: "bar",
  avg_spend: emptyQuarterlyAverageMetric,
  avg_kg: emptyQuarterlyAverageMetric,
  avg_items: emptyQuarterlyAverageMetric,
};
export const emptySinglePanelChart = { title: "", subtitle: "", type: "bar", series: [], data: [] };
export const initialCharts = {
  difotByPeriod: emptyDeliveryPerformanceChart,
  monthlyFreightSpend: emptyFreightSpendTrendChart,
  quarterlyAverages: emptyQuarterlyAveragesChart,
  freightSpendByFromState: emptySinglePanelChart,
  freightSpendByToState: emptySinglePanelChart,
};

export const QUARTERLY_METRIC_COLORS = {
  avg_spend: { light: "#ffd3d5", dark: CORAL },
  avg_kg: { light: "#aab8cf", dark: NAVY },
  avg_items: { light: "#b9cbe3", dark: BLUE },
};
